import { render } from "./cte-list-cota-assinc.vue?vue&type=template&id=5a7ebc6f"
import script from "./cte-list-cota-assinc.vue?vue&type=script&lang=js"
export * from "./cte-list-cota-assinc.vue?vue&type=script&lang=js"

import "./cte-list-cota-assinc.vue?vue&type=style&index=0&id=5a7ebc6f&lang=css"

import exportComponent from "/home/econopro-ubuntu/Documents/econopro/fonts/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__